<template>
  <v-container>
    <img src="../assets/breadcrumb2.svg" />
    <v-data-table :items="items" class="mx-5" hide-headers hide-actions>
      <template slot="items" slot-scope="props">
        <td>{{ props.item.name | capitalize }}</td>
        <td>{{ props.item.price | toDollars }}</td>
      </template>
      <template slot="footer">
        <td><strong>Total</strong></td>
        <td>
          <strong>{{ total | toDollars }}</strong>
        </td>
      </template>
    </v-data-table>
    <v-layout justify-space-around>
      <v-btn @click="$router.go(-1);">Back</v-btn>
      <v-btn color="success" @click="done">Place Order</v-btn>
    </v-layout>
  </v-container>
</template>

<script>
import { capitalize, sumBy } from 'lodash-es';
import firebase from 'firebase/app';
import 'firebase/database';
import { mapState } from 'vuex';

const db = firebase.database;

export default {
  filters: {
    capitalize,
    toDollars: value => `$${(value / 100).toFixed(2)}`,
  },
  computed: {
    ...mapState(['token', 'state', 'type', 'packageName', 'price']),
    items() {
      return [
        { name: this.packageName, price: this.price.package },
        { name: this.state, price: this.price.state },
      ];
    },
    total() {
      return sumBy(this.items, 'price');
    },
  },
  methods: {
    done() {
      this.$checkout.open({
        amount: this.total,
        token: source =>
          db()
            .ref('charges')
            .push({
              token: this.token,
              source,
            }),
      });
    },
  },
};
</script>
